import React, { useEffect, useState } from 'react';
import data from '../../products.json';
import { useParams, useSearchParams } from 'react-router-dom';
import axios from 'axios';
import { useOutletContext } from 'react-router-dom';

const CheckoutPage = ({ lang }) => {
  const [searchParams] = useSearchParams();
  
  const productsFromParams = JSON.parse(searchParams.get('products'));
  const [dictionary, setDictionary] = useOutletContext();
  const productsIdArray = productsFromParams.map(el => el.id);
  const prodDataRaw = []
  data.forEach((cat) => {
    cat.product.forEach(prod=>{
      if(productsIdArray.includes(prod.id)){
        prodDataRaw.push(prod)
      }
    })
  })
  const prodData = prodDataRaw.filter(el => {
    if (el != undefined && productsIdArray.includes(el.id)) {
      return el;
    }
  });

  const [omniva, setOmniva] = useState(null);
  const [formErrors, setFormErrors] = useState({});
  const [isSubmitted, setIsSubmitted] = useState(false);

  useEffect(() => {
    const setAddress = async () => await axios.get('https://www.omniva.lv/locations.json', { headers: { 'accept-encoding': null } }).then(result => { setOmniva(result.data) });
    setAddress();
  }, []);

  const [formData, setFormData] = useState({
    firstName: '',
    lastName: '',
    email: '',
    address: '',
    city: '',
    zipCode: '',
    cardNumber: '',
    cardName: '',
    expiry: '',
    cvv: '',
    delivery: "omniva",
    payment: "card"
  });

  const [loading, setLoading] = useState(false);

  // Validation function
  const validateForm = () => {
    const errors = {};
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    if (!formData.firstName.trim()) errors.firstName = dictionary.nameRequired || 'Name is required';
    if (!formData.lastName.trim()) errors.lastName = dictionary.lastNameRequired || 'Last name is required';
    if (!formData.email.trim()) {
      errors.email = dictionary.emailRequired || 'Email is required';
    } else if (!emailRegex.test(formData.email)) {
      errors.email = dictionary.invalidEmail || 'Invalid email format';
    }
    
    // Add delivery validation if needed
    if (formData.delivery === "omniva" && !document.getElementById("parcel")?.value) {
      errors.delivery = dictionary.deliveryRequired || 'Please select a delivery point';
    }

    setFormErrors(errors);
    return Object.keys(errors).length === 0;
  };

  const handleCheckout = async (e) => {
    e.preventDefault();
    setIsSubmitted(true);
    
    if (!validateForm()) {
      return;
    }

    setLoading(true);
    try {
      const dataToSend = {
        products: productsFromParams,
        client: {
          "name": formData.firstName + " " + formData.lastName,
          "email": formData.email,
          "lang": "lv",
          "payment": formData.payment,
          "delivery": formData.delivery == "omniva" ? "Omniva-" + document.getElementById("parcel").value : "Uz vietas"
        }
      }

      const response = await axios.post(
        'https://api.carlgustafbags.com/api/payment/create-checkout-session', dataToSend
      );
      window.location.href = response.data;
    } catch (error) {
      console.error("Error:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
    
    // Clear error when user starts typing
    if (formErrors[name]) {
      setFormErrors(prev => ({
        ...prev,
        [name]: ''
      }));
    }
  };

  return (
    <div className="container py-5">
      <div className="row">
        <div className="col-md-8">
          <div className="card mb-4">
            <div className="card-header bg-success text-white">
              <h4 className="mb-0">{dictionary.information}</h4>
            </div>
            <div className="card-body">
              <form onSubmit={handleCheckout}>
                <div className="row">
                  <div className="col-md-6 mb-3">
                    <label htmlFor="firstName" className="form-label">{dictionary.name}</label>
                    <input
                      type="text"
                      className={`form-control ${formErrors.firstName ? 'is-invalid' : ''}`}
                      id="firstName"
                      name="firstName"
                      value={formData.firstName}
                      onChange={handleChange}
                      required
                    />
                    {formErrors.firstName && <div className="invalid-feedback">{formErrors.firstName}</div>}
                  </div>
                  <div className="col-md-6 mb-3">
                    <label htmlFor="lastName" className="form-label">{dictionary.lastname}</label>
                    <input
                      type="text"
                      className={`form-control ${formErrors.lastName ? 'is-invalid' : ''}`}
                      id="lastName"
                      name="lastName"
                      value={formData.lastName}
                      onChange={handleChange}
                      required
                    />
                    {formErrors.lastName && <div className="invalid-feedback">{formErrors.lastName}</div>}
                  </div>
                </div>

                <div className="mb-3">
                  <label htmlFor="email" className="form-label">{dictionary.email}</label>
                  <input
                    type="email"
                    className={`form-control ${formErrors.email ? 'is-invalid' : ''}`}
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                    required
                  />
                  {formErrors.email && <div className="invalid-feedback">{formErrors.email}</div>}
                </div>
              </form>
            </div>
          </div>
          
          <div className="card mb-4">
            <div className="card-header bg-success text-white">
              <h4 className="mb-0">{dictionary.delivery}</h4>
            </div>
            <div className="card-body mb-3">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <button 
                    type="button"
                    className={`btn border border-2 ${formData?.delivery == "omniva" ? "border-success" : ""}`} 
                    style={{ fontSize: 25 }} 
                    onClick={() => setFormData(prev => ({
                      ...prev,
                      delivery: "omniva"
                    }))}
                  >
                    Omniva
                  </button>
                </div>
                <div className="col-md-6 mb-3">
                  <button 
                    type="button"
                    className={`btn border border-2 ${formData?.delivery == "uz-vietas" ? "border-success" : ""}`} 
                    style={{ fontSize: 25 }} 
                    onClick={() => setFormData(prev => ({
                      ...prev,
                      delivery: "uz-vietas"
                    }))}
                  >
                    {dictionary.atShop}
                  </button>
                </div>
              </div>
              {formData.delivery == "omniva" ? (
                <>
                  <select 
                    id='parcel' 
                    className={`form-select ${formErrors.delivery ? 'is-invalid' : ''}`}
                    aria-label="Default select example"
                  >
                    <option value="">{dictionary.selectOption || 'Izvēlēties...'}</option>
                    {omniva != null ?
                      omniva.map(address => {
                        if (address.A0_NAME == "LV") {
                          return <option value={address.NAME}>{address.NAME}</option>
                        }
                      }) : <div></div>
                    }
                  </select>
                  {formErrors.delivery && <div className="invalid-feedback d-block">{formErrors.delivery}</div>}
                </>
              ) : <div></div>}
            </div>
          </div>

          <div className="card mb-4">
            <div className="card-header bg-success text-white">
              <h4 className="mb-0">{dictionary.paymentMethod}</h4>
            </div>
            <div className="mb-3 card-body">
              <div className="row">
                <div className="col-md-6 mb-3">
                  <button 
                    type="button"
                    className={`btn border border-2 ${formData?.payment == "card" ? "border-success" : ""}`} 
                    style={{ fontSize: 25 }} 
                    onClick={() => setFormData(prev => ({
                      ...prev,
                      payment: "card"
                    }))}
                  >
                    {dictionary.bankCard}
                  </button>
                </div>
                <div className="col-md-6 mb-3">
                  <button 
                    disabled
                    type="button"
                    className={`btn border border-2 ${formData?.payment == "invoice" ? "border-success" : ""}`} 
                    style={{ fontSize: 25 }} 
                    onClick={() => setFormData(prev => ({
                      ...prev,
                      payment: "invoice"
                    }))}
                  >
                    {dictionary.bankTransfer}
                  </button>
                </div>
              </div>
              <hr className="my-4" />
              <button 
                onClick={handleCheckout} 
                disabled={loading} 
                className="btn btn-success btn-lg btn-block" 
                type="button"
              >
                {loading ? 'Uzgaidiet...' : (lang == "lv" ? 'Veikt pirkumu' : "Purchase")}
              </button>
            </div>
          </div>
        </div>

        <div className="col-md-4">
          <div className="card mb-4">
            <div className="card-header bg-success text-white">
              <h4 className="mb-0">{dictionary.orderedProducts}</h4>
            </div>
            <div className="card-body">
              <ul className="list-group mb-3">
                {prodData.map(prod => (
                  <li key={prod.id} className="list-group-item d-flex justify-content-between lh-condensed">
                    <div>
                      <h6 className="my-0">{lang == "lv" ? prod.nameLV : prod.name}</h6>
                      <small className="text-muted"></small>
                    </div>
                    <span className="text-muted">€{prod.price}</span>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CheckoutPage;